// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__17O0f","tab":"ProcedureTabs_tab__3DtjV"};